import { NoSidebarLayout } from 'components/Layouts/NoSidebarLayout';
import {
  AboutBlockMenu,
  InternalBlockMenu,
} from 'components/Menu/InternalBlockMenu';
import { PrimaryButton } from 'components/UI/Buttons/PrimaryButton';
import { Text } from 'components/UI/Typography/Text';

import styles from './ContactInfo.module.scss';

export const ContactInfo = () => {
  return (
    <NoSidebarLayout>
      <InternalBlockMenu list={AboutBlockMenu} />
      <section className={styles.contactContainer}>
        <div className={styles.contactWrapper}>
          <header>
            <Text className={styles.textDisplay} variant="h1">
              Our Office
            </Text>
          </header>
          <Text className={styles.emailDisplay} variant="body2">
            <a
              href="mailto:support@on3.zendesk.com?subject=Support%20Request&body=My%20username%20and%20email:I%20am%20following%20this%20team:"
              title="email on3"
            >
              support@on3.com
            </a>
          </Text>
          <Text className={styles.contactInfo} variant="body2">
            2970 Foster Creighton Drive
          </Text>
          <Text className={styles.contactInfo} variant="body2">
            Nashville, TN 37204
          </Text>
          <div className={styles.contactButtons}>
            <PrimaryButton
              className={styles.emailButton}
              href="https://on3.zendesk.com/hc/en-us"
              title="Customer Service"
              variant="outlined"
            >
              <Text className={styles.buttonText} variant="subtitle1">
                Customer Service
              </Text>
            </PrimaryButton>
            <PrimaryButton
              className={styles.emailButton}
              href="mailto:recruiting@on3.com?subject=Recruiting%20Inquiries&body=I%20have%20an%20recruiting%20inquiry:"
              title="email recruiting on3"
              variant="outlined"
            >
              <Text className={styles.buttonText} variant="subtitle1">
                Recruiting Inquiries
              </Text>
            </PrimaryButton>
          </div>
        </div>
        <div className={styles.mapImage}>
          <iframe
            frameBorder="0"
            height="100%"
            id="gmap_canvas"
            scrolling="no"
            src="https://maps.google.com/maps?q=2970+Foster+Creighton+Dr,+Nashville,+TN+37204&t=&z=13&ie=UTF8&iwloc=&output=embed"
            title="Office Location"
            width="100%"
          />
        </div>
      </section>
    </NoSidebarLayout>
  );
};
